import styled from "styled-components";
import Theme from "../Theme";
import { ReactNode } from "react";

export interface IHeaderProps {
  center?: boolean;
  notFirst?: boolean;
  children: ReactNode;
}

export const H1 = styled.h1<IHeaderProps>`
  font-family: ${Theme.fonts.header};
  font-size: 48px;
  font-weight: 700;
  line-height: 65px;
  width: 100%;

  ${props =>
    props.center &&
    `
    text-align: center;
  `}
`;

export const H2 = styled.h2<IHeaderProps>`
  font-family: ${Theme.fonts.header};
  font-size: 48px;
  font-weight: 700;
  line-height: 65px;
  margin-top: 0;
  width: 100%;

  ${props =>
    props.center &&
    `
    text-align: center;
  `}

  ${props =>
    props.notFirst &&
    `
    margin-top: 60px;
  `}
`;

export const H3 = styled.h3<IHeaderProps>`
  font-family: ${Theme.fonts.header};
  font-size: 36px;
  font-weight: 500;
  line-height: 45px;
  width: 100%;

  ${props =>
    props.center &&
    `
    text-align: center;
  `}
`;

export const H4 = styled.h4`
  font-family: ${Theme.fonts.header};
  font-size: 36px;
  font-weight: 700;
  line-height: 65px;
`;

export const H5 = styled.h5`
  font-family: ${Theme.fonts.header};
  font-size: 24px;
  font-weight: 700;
  line-height: 65px;
`;

export const H6 = styled.h6`
  font-family: ${Theme.fonts.header};
  font-size: 24px;
  font-weight: 500;
  line-height: 65px;
`;
